




import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class StepOptionRadio extends Vue {
  @Prop({ default: false }) checked!: boolean
}
